import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import usePermissions from 'hooks/usePermissions';
import StatusBadge from 'ui-component/StatusBadge';
import useIsMobile from 'utils/isMobileUtils';


const PicklistComponent = ({ details }) => {
    const [allPermissions, hasEveryPermission] = usePermissions();
    const history = useNavigate();
    const isMobile = useIsMobile();

    const handleOpenNewTab = (pageModule, id) => {
        let url = '';
        if (pageModule == 'products') {
            url = `/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = `/sales/sales-orders/${id}`;
        } else if (pageModule == 'picklists') {
            url = `/picklists/${id}`;
        }
        if (url) {
            history(url);
        }
    };

    return (
        !isMobile ? (
            <div style={{ padding: '0px 20px 20px 16px' }}>
                <div className="row mb10">
                    <div className="col-12">
                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>Picklists</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2 font600">Picklist #</div>
                    <div className="col-md-4 font600">Product</div>
                    <div className="col-md-2 font600">Qty</div>
                    <div className="col-md-2 font600">Status</div>
                    <div className="col-md-2 font600">Date</div>
                </div>
                <hr className="mt8 mb8" />
                {details?.map((picklist, index) => (
                    <React.Fragment key={picklist?.id || index}>
                        {picklist?.items?.map((item, i) => (
                            <React.Fragment key={item?.id || i}>
                                <div className="row">
                                    <div className="col-md-2 d-flex align-item-center">
                                        <div
                                            className={`${hasEveryPermission(['View Picklists Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Picklists Details (Page)'])) {
                                                    handleOpenNewTab('picklists', picklist?.id)
                                                }
                                            }}
                                        >
                                            {picklist?.picklist_no}
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-item-center">
                                        <div
                                            className={`${hasEveryPermission(['View Product (Button)']) ? 'text-primary cursor-pointer' : ''}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Product (Button)'])) {
                                                    handleOpenNewTab('products', item?.product?.id)
                                                }
                                            }}
                                        >
                                            {item?.product?.name}
                                        </div>
                                    </div>
                                    <div className={`${item?.collected_quantity >= item?.quantity ? 'text-success' : ''} col-md-2 d-flex align-item-center`}>
                                        {item?.collected_quantity}/{item?.quantity}
                                    </div>
                                    <div className="col-md-2 d-flex align-item-center">
                                        <div style={{ width: '80px' }}>
                                            <StatusBadge itemStatus={picklist?.status?.name} />
                                        </div>
                                    </div>
                                    <div className="col-md-2 d-flex align-item-center">
                                        {moment(item?.created_date).format(CommonDateOnlyFormat)}
                                    </div>
                                </div>
                                <hr className="mt8 mb8" />
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                ))}
            </div>
        ) : (
            // --- MOBILE VERSION ---
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h2 className="d-flex font600" style={{ fontSize: '18px', paddingBottom: 10, borderBottom: '1px solid #e0e0e0' }}>Picklists</h2>
                {details?.map((picklist, index) => (
                    <React.Fragment key={picklist?.id || index}>
                        {picklist?.items?.map((item, i) => (
                            <div
                                key={item?.id || i}
                                style={{
                                    borderBottom: '1px solid #eee',
                                    paddingTop: 12,
                                    paddingBottom: 12,
                                    background: '#fff'
                                }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                    <div style={{fontWeight: 500,  fontSize: 13 }}>
                                        Picklist #:
                                        <span
                                            className={`${hasEveryPermission(['View Picklists Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Picklists Details (Page)'])) {
                                                    handleOpenNewTab('picklists', picklist?.id)
                                                }
                                            }}
                                            style={{marginLeft: 6}}
                                        >
                                            {picklist?.picklist_no}
                                        </span>
                                    </div>
                                    <div style={{ fontWeight: 400, fontSize: 13 }}>
                                        {moment(item?.created_date).format(CommonDateOnlyFormat)}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                    <div
                                        className={`${hasEveryPermission(['View Product (Button)']) ? 'text-primary cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (hasEveryPermission(['View Product (Button)'])) {
                                                handleOpenNewTab('products', item?.product?.id)
                                            }
                                        }}
                                        style={{ fontWeight: 500, fontSize: 13 }}
                                    >
                                        {item?.product?.name}
                                    </div>
                                    <div style={{ fontWeight: 500, fontSize: 13 }}>
                                        {item?.collected_quantity}/{item?.quantity}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginBottom: 6 }}>
                                    <div style={{ fontSize: 12, color: '#888' }}>
                                        <StatusBadge itemStatus={picklist?.status?.name} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </React.Fragment>
                ))}
            </div>
        )
    );
};

export default PicklistComponent;
